import {ErrorHandler, inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../userInterface/toast.service';
import {WebsocketConnectionException} from '../../models/exception/WebsocketConnectionException';

export class GlobalErrorHandler implements ErrorHandler {
    private readonly translateService: TranslateService = inject(TranslateService);
    private readonly toastService: ToastService = inject(ToastService);

    public async handleError(error: any): Promise<void> {
        const messageKey: string | undefined = this.getErrorMessageKey(error);
        if (messageKey) {
            const message = this.translateService.instant(messageKey);
            await this.toastService.showErrorMessage(message);
        }
    }

    private getErrorMessageKey(error: any): string | undefined {
        let messageKey: string | undefined = undefined;

        if (error instanceof WebsocketConnectionException)
            messageKey = "toastMessage.error.websocketConnectionFailureMessage";

        return messageKey;
    }
}
